// // src/api/metrics.js
// import axios from 'axios';
// import { API_URLS } from './config';

// const API_URL = API_URLS.API;

// export const METRICS_ENDPOINTS = {
//   // Remove trailing slash to match your actual API endpoint structure
//   PRODUCT_DETAIL: `${API_URL}/trends/metrics/product`,
// };

// export const getProductMetrics = async (productId) => {
//   try {
//     console.log('Calling API at:', METRICS_ENDPOINTS.PRODUCT_DETAIL);
//     console.log('With product ID:', productId);
    
//     const response = await axios.post(METRICS_ENDPOINTS.PRODUCT_DETAIL, {
//       group_id: productId
//     });
    
//     return response.data;
//   } catch (error) {
//     console.error('Full error details:', error);
//     throw error;
//   }
// };

// src/api/metrics.js
import axios from 'axios';
import { API_URLS } from './config';
import { applyBrandNameCorrections } from '../utils/brandNameCorrections';

const API_URL = API_URLS.API;

export const METRICS_ENDPOINTS = {
  // Updated to use path parameters instead of request body
  PRODUCT_DETAIL: `${API_URL}/trends/metrics/product`,
};

export const getProductMetrics = async (productId, language = 'ko') => {
  try {
    // Construct URL with path parameter and query parameter
    const url = `${METRICS_ENDPOINTS.PRODUCT_DETAIL}/${productId}`;
    const params = { lang: language };
    
    console.log('Calling API at:', url);
    console.log('With product ID:', productId);
    console.log('With language:', language);
    
    // Changed from POST to GET with query parameters
    const response = await axios.get(url, { params });

    return applyBrandNameCorrections(response.data, language);
  } catch (error) {
    console.error('Full error details:', error);
    throw error;
  }
};